import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ErrorModal from '@components/dialogs/ErrorModal.component.jsx';
import EventLayout from '@layouts/Event.layout.jsx';

export default function PromoterAccessError({ showPreloader, onButtonClick }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const reload = () => navigate('/');

  return (
    <EventLayout showPreloader={showPreloader}>
      <ErrorModal
        header={t('printer.promoterAccessError.title')}
        description={t('printer.promoterAccessError.description')}
        buttonText={t('printer.promoterAccessError.button')}
        onButtonClick={onButtonClick ?? reload}
      />
    </EventLayout>
  );
}
